import React, { useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { StartupShowcaseBreadCrum } from '../core/_constants'
import RectangularTabs from '../../widgets/components/RectangularTabs'
import OtherStartups from '../components/OtherStartups'
import YourStartups from '../components/YourStartups'
import Share from '../../../../media/images/share.svg'
import ShareModal from '../../widgets/components/ShareModal'
// import { useAuth } from '../../auth'

const StartupShowcase = () => {
  const { formatMessage } = useIntl()
  // const { planStatus } = useAuth()
  const [isActive, setIsActive] = useState(false)
  const [urlToShare, setUrlToShare] = useState('')

  const handleModal = (url: any) => {
    setIsActive(() => !isActive)
    setUrlToShare(url)
    setIsActive(true)
  }

  const options = [
    {
      id: 1,
      slug: 'Vote-For-Other-Startups',
      title: formatMessage({ id: 'Vote For Other Startups' }),
      subTitle: formatMessage({ id: 'Explore the List of Startups You Can Vote For' }),
    },
    {
      id: 2,
      slug: 'Publish Your Startup',
      title: formatMessage({ id: 'Publish Your Startup' }),
      subTitle: formatMessage({ id: 'Submit Your Startup for Voting by Others' }),
    },
  ]

  // State for managing the selected tab
  const [selectedTab, setSelectedTab] = useState<number>(1)

  const handleTabChange = (id: number) => {
    setSelectedTab(id)
  }



  return (
    <div className='px-6'>
      <PageTitle
        breadcrumbs={StartupShowcaseBreadCrum}
        description={formatMessage({ id: 'Startup Showcase' })}
      >
        {formatMessage({ id: 'Startup Showcase' })}
      </PageTitle>
      {/* button for Desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'}  ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}
      >
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end gap-4'>
            <button
              className={`btn btn-bg-primary font-size-13 text-white font-weight-400 w-100 ${selectedTab !== 2 && 'd-none'
                }`}
            // onClick={() => navigate('../add-stakeholder?tab=individual')}
            >
              {formatMessage({ id: 'Publish Your Startup' })}
            </button>
            <button
              className={`btn m-0 p-0 d-block ${selectedTab !== 2 && 'd-none'}`}
              onClick={() => handleModal(window.location.href)}
            >
              <img
                src={Share}
                alt='share'
                className='share align-self-center'
                style={{ height: '24px', width: '24px' }}
              />
            </button>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end align-items-baseline'>
            <button
              className={`btn btn-bg-primary font-size-13 text-white mb-4 font-weight-400 w-100 ${selectedTab !== 2 && 'd-none'
                }`}
            // onClick={() => navigate('../add-stakeholder')}
            >
              {formatMessage({ id: 'Publish Your Startup' })}
            </button>
            <button
              className={`btn m-0 p-0 d-block ${selectedTab !== 2 && 'd-none'}`}
              onClick={() => handleModal(window.location.href)}
            >
              <img
                src={Share}
                alt='share'
                className='share align-self-center ms-2 ms-md-0'
                style={{ height: '24px', width: '24px' }}
              />
            </button>
          </div>
        </div>
      </div>
      {isActive && <ShareModal isActive={isActive} setIsActive={setIsActive} url={urlToShare} />}
      <RectangularTabs
        options={options}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
      />
      <div className='my-auto w-100 '>
        {selectedTab === 1 && <OtherStartups />}

        {selectedTab === 2 && <YourStartups />}
      </div>
    </div >
  )
}

export default StartupShowcase
